module.exports = __webpack_public_path__ + "static/media/toyota.c4011ab5.png";